
import { Link } from 'react-router-dom';
import React from 'react';

export default function ArticleCard ({ article }) {
  return (
    // Usa Link para navegar para a página de detalhes
    <Link
      to={`artigos/${article.id}`}
      className="block bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:scale-[1.02] cursor-pointer"
    >
      {/* Imagem no topo */}
      <div className="h-48 overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Conteúdo do Card */}
      <div className="p-6 flex flex-col justify-between h-[calc(100%-12rem)]"> {/* 12rem = 48 (altura da imagem) */}
        <div>
          {/* Tipo (Badge) */}
          <span className="inline-block bg-black text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider mb-3">
            {article.type}
          </span>

          {/* Título */}
          <p className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
            {article.title}
          </p>

          {/* Descrição Curta */}
          <p className="text-base text-gray-600 mb-4 line-clamp-3">
            {article.description.substring(0, 150)}...
          </p>
        </div>

        {/* Data e Link de Leitura */}
        <div className="mt-auto flex justify-between items-center text-sm text-gray-500 pt-4 border-t border-gray-100">
          <span className="font-medium">{article.date}</span>
          <span className="text-black font-semibold flex items-center gap-1">
            Ler mais
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 transform -rotate-45"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </span>
        </div>
      </div>
    </Link>
  );
};